import React from "react";
import { VisuallyHidden } from "react-aria-components";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";

import styles from "./index.module.scss";

export function SKSDots({
    allVisible,
    slideCount,
    pageCount,
    className,
}: {
    allVisible: boolean;
    slideCount: number;
    pageCount?: number;
    className?: string;
}) {
    if (allVisible) return null;
    const usePages = pageCount !== undefined;
    const count = usePages ? pageCount : slideCount;
    const slotPrefix = usePages ? "page" : "slide";
    return (
        <div className={concatClassNames([styles.dots, className])}>
            {Array.from({ length: count }).map((_, i) => (
                <Clickable key={i} slot={`${slotPrefix}-${i}`}>
                    <VisuallyHidden>{`${i + 1} of ${count}`}</VisuallyHidden>
                </Clickable>
            ))}
        </div>
    );
}
